<template>
  <v-container class="mt-16" id="Products" fluid tag="section">
    <v-dialog  persistent  width="90%" height="80%" v-model="showpic">
     
                <v-img contain aspect-ratio="2.2"  d :src="getImgUrl(picNumber)">
          <v-btn icon @click="showpic = false">
            <v-icon color="white" large>mdi-close</v-icon>
          </v-btn>
          </v-img>
           
          
         
                 

            
         
      
      
   
    </v-dialog>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-container fluid>
            <v-row>
              <v-col
                v-for="n in picCount"
                :key="n"
                class="d-flex child-flex"
                cols="4"
              >
                <v-card flat tile class="d-flex">
                  <v-img
                    style="cursor: pointer;"
                    @click="showpicMethod(n)"
                    :src="getImgUrl(n)"
                    :lazy-src="getImgUrl(n)"
                    aspect-ratio="1"
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      picNumber: 1,
      picCount: 14,
      showpic: false
    };
  },
  methods: {
    showpicMethod(n) {
      this.picNumber = n;
      this.showpic = true;
    },
    getImgUrl(pet) {
      debugger;
      var images = require.context(
        "../../../assets/gallery/",
        false,
        /\.jpeg$/
      );
      return images("./" + pet + ".jpeg");
    }
  }
};
</script>
